import { requestNotificationPermission, safeNotify } from './notifications'
import { isShoppingEve } from './restockCalculator'

// ─── sendRestockNotification ──────────────────────────────────────────────────

export async function sendRestockNotification(
  itemCount:      number,
  estimatedTotal: number,
): Promise<void> {
  const formattedTotal = estimatedTotal > 0
    ? ` · Est. $${estimatedTotal.toFixed(2)}`
    : ''

  await safeNotify('Tomorrow is your shopping day 🛒', {
    body:             `${itemCount} item${itemCount !== 1 ? 's' : ''} running low${formattedTotal}. Tap to see your list.`,
    icon:             '/pwa-192.png',
    tag:              'restock-reminder',
    requireInteraction: false,
  })
}

// ─── checkAndSendRestockNotification ─────────────────────────────────────────

export async function checkAndSendRestockNotification(
  shoppingDay:          number,
  itemCount:            number,
  estimatedTotal:       number,
  notificationsEnabled: boolean,
): Promise<void> {
  if (!notificationsEnabled) return
  if (!isShoppingEve(shoppingDay)) return

  // Only send once per calendar day
  const lastSent = localStorage.getItem('pantry-restock-notification-date')
  const today    = new Date().toDateString()
  if (lastSent === today) return

  const granted = await requestNotificationPermission()
  if (!granted) return

  await sendRestockNotification(itemCount, estimatedTotal)

  localStorage.setItem('pantry-restock-notification-date', today)
}
